import User from './User.js'
import Users from './Users.js'
import Timer from './Timer.js'
import System from './System.js'
import Device from './Device.js'
import Script from './Script.js'
import Template from './Template.js'
import Project from './Project.js'
import Scenario from './Scenario.js'
import Blueprint from './Blueprint.js'
import Interface from './Interface.js'
import RouteUtils from './RouteUtils.js'

export default {

  collection : RouteUtils.collection,

  user : User,
  users : Users,
  timer : Timer,
  system : System,
  device : Device,
  script : Script,
  template : Template,
  team : Project, // old, dont use
  project : Project,
  scenario : Scenario,
  blueprint : Blueprint,
  interface : Interface,

  messageRoute : RouteUtils.dataObject( 'messageRoute', 'project', 'projectId' ),
  oidcClient : RouteUtils.dataObject( 'oidcClient', 'project', 'projectId' ),
  apiAccess : RouteUtils.dataObject( 'apiAccess', 'project', 'projectId' ),
  network : RouteUtils.dataObject( 'network', 'project', 'projectId' ),
  // scenario : RouteUtils.dataObject( 'scenario', 'project', 'projectId' ),
  attribute : RouteUtils.dataObject( 'attribute', 'blueprint', 'blueprintId' ),

  RouteUtils
}
